export default {
  common: {
    save: "Änderungen speichern",
    cancel: "Abbrechen",
    saving: "Speichern...",
    updating: "Aktualisieren...",
    back: "Zurück",
    error: "Fehler",
    in: "in",
    success: "Erfolg",
    toast: {
      success: "Erfolg",
      error: "Fehler",
      info: "Information",
      warning: "Warnung",
      copied: "In die Zwischenablage kopiert",
      saved: "Änderungen gespeichert",
      deleted: "Erfolgreich gelöscht",
      updated: "Erfolgreich aktualisiert"
    }
  },
  tripCard: {
    daysLeft: "Tage",
    flightDetails: "Flugdetails",
    terminal: "Terminal",
    gate: "Gate",
    checkIn: "Check-in",
    flightInfo: "Fluginformationen",
    airline: "Fluggesellschaft",
    flight: "Flug",
    departure: "Abflug",
    arrival: "Ankunft",
    getFlightDetails: "Flugdetails",
    destinationInfo: "Zielinfo",
    weather: "Wetter",
    activities: "Empfohlene Aktivitäten",
    food: "Restaurants & Cafés",
    today: "Heute",
    dayAgo: "Vor 1 Tag",
    daysAgo: "Vor {{count}} Tagen",
    remainingDay: "1 verbleibender Tag",
    remainingDays: "{{count}} verbleibende Tage",
    checkStatus: "Status prüfen",
    tripStatus: {
      ongoing: "Laufende Reise",
      upcoming: "Bevorstehende Reise",
      past: "Vergangene Reise"
    },
    booking: "Buchung",
    taxiTransfer: "Taxi Transfer",
    taxiTransferDesc: "Buchen Sie einen Taxi-Transfer zu Ihrem Hotel oder Flughafen",
    taxiTransferComingSoon: "Taxi-Transfer bald verfügbar",
    tripDetails: "Reisedetails",
    deleteTrip: "Reise löschen",
    confirmDelete: "Reise löschen?",
    deleteWarning: "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird Ihre Reise nach {{tripName}} dauerhaft löschen und aus Ihrem Konto entfernen.",
    confirmDeleteButton: "Ja, Reise löschen",
    tripDeleted: "Die Reise wurde erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen der Reise",
    cabinClass: "Kabinenklasse",
    bookingReference: "Buchungsreferenz",
    confirmationNumbers: "Bestätigungsnummern",
    carRental: "Mietwagen",
    carModel: "Fahrzeugmodell",
    pickupLocation: "Abholort",
    dropoffLocation: "Rückgabeort",
    pickup: "Abholung",
    dropoff: "Rückgabe",
    confirmationNumber: "Bestätigungsnummer",
    addToCalendar: "Zum Kalender hinzufügen",
    notifications: "Benachrichtigungen",
    notificationsDescription: "Wichtige Benachrichtigungen zu Ihren Reisen",
    noNotifications: "Noch keine Benachrichtigungen",
    notificationsOnMobile: "Diese Funktion ist derzeit nur in der mobilen App verfügbar",
    loadingNotifications: "Benachrichtigungen werden geladen...",
    economy: "Economy"
  },
  auth: {
    signOut: "Abmelden",
    signOutSuccess: "Erfolgreich abgemeldet",
    redirectingHome: "Weiterleitung zur Startseite...",
    loginWithEmail: "Mit E-Mail anmelden",
    createAccount: "Konto erstellen",
    forgotPassword: "Passwort vergessen",
    forgotPasswordInstructions: "Bitte melden Sie sich mit Ihrer E-Mail an und ändern Sie dann Ihr Passwort",
    firstName: "Vorname",
    lastName: "Nachname",
    emailAddress: "E-Mail-Adresse",
    confirmEmailAddress: "E-Mail-Adresse bestätigen",
    termsAgreementPart1: "Durch die Erstellung Ihres Kontos stimmen Sie unseren",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinien",
    signUpToManageTrips: "Registrieren Sie sich, um Ihre Reisen zu verwalten",
    enterEmailForCode: "Geben Sie Ihre E-Mail-Adresse ein, um einen Einmalcode zu erhalten",
    verifyEmail: "E-Mail verifizieren",
    passwordValidation: "Das Passwort muss mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl, ein Sonderzeichen enthalten und zwischen 8 und 15 Zeichen lang sein.",
    noAccount: "Kein Konto? Registrieren",
    adtdTripPWaiting: "Ihre Reise ist bereit zum Import",
    adtdTripPWaitingDescription: "Bitte melden Sie sich bei Ihrem Konto an oder erstellen Sie eines, um fortzufahren. Wir werden sicherstellen, dass die Buchung mit Ihrer Identität übereinstimmt.",
    loginDescription: "Verfolgen Sie Ihre Flüge, organisieren Sie Ihre Reisen und greifen Sie auf alle Ihre Reiseinformationen zu. Alles, was Sie für eine reibungslose Reise brauchen, an einem Ort.",
    loginAppDescription: "Alle Ihre Reiseinformationen an einem Ort"
  },
  settings: {
    title: "Einstellungen",
    profile: {
      title: "Mein Profil",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail-Adresse",
      country: "Land",
      city: "Stadt",
      selectCountry: "Land auswählen oder eingeben",
      enterCity: "Ihre Stadt eingeben"
    },
    language: {
      title: "Sprache",
      preferred: "Bevorzugte Sprache"
    },
    currency: {
      title: "Währung",
      preferred: "Bevorzugte Währung"
    },
    notifications: {
      title: "Benachrichtigungen",
      emailNotifications: "E-Mail-Benachrichtigungen",
      description: "Erhalten Sie E-Mail-Benachrichtigungen über wichtige Updates"
    },
    consent: {
      title: "Einwilligungsverwaltung",
      open: "Einwilligungsmanager öffnen",
      description: "Verwalten Sie Ihre Datenschutz- und Cookie-Einstellungen"
    },
    about: {
      title: "Über uns",
      tos: "Nutzungsbedingungen",
      privacy: "Datenschutzrichtlinie",
      faq: "FAQ"
    },
    contact: {
      title: "Kontaktieren Sie uns",
      email: "feedback@checkmytrip.com"
    },
    social: {
      title: "Finden Sie uns in sozialen Medien"
    },
    profileUpdated: "Profil erfolgreich aktualisiert",
    updateError: "Fehler beim Aktualisieren des Profils",
    passwordMismatch: "Passwörter stimmen nicht überein",
    passwordTooShort: "Das Passwort muss mindestens 8 Zeichen lang sein",
    passwordUpdated: "Passwort erfolgreich aktualisiert",
    changePassword: "Passwort ändern",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    updatePassword: "Passwort aktualisieren",
    deleteAccount: "Konto löschen",
    deleteAccountDescription: "Löschen Sie Ihr Konto und alle zugehörigen Daten dauerhaft",
    confirmDelete: "Sind Sie sicher?",
    deleteWarning: "Diese Aktion kann nicht rückgängig gemacht werden. Dies wird Ihr Konto dauerhaft löschen und alle Ihre Daten von unseren Servern entfernen.",
    confirmDeleteButton: "Ja, mein Konto löschen",
    accountDeleted: "Ihr Konto wurde erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen des Kontos",
    feedback: {
      title: "Feedback",
      description: "Wir schätzen Ihr Feedback. Helfen Sie uns, unseren Service zu verbessern, indem Sie Ihre Gedanken teilen.",
      button: "Feedback geben"
    }
  },
  discover: {
    title: "Entdecke Erlebnisse",
    subtitle: "Finde und erkunde Aktivitäten für dein nächstes Abenteuer",
    getInspired: "Lass dich inspirieren",
    searchFilters: "Suchfilter",
    search: "Suche",
    city: "Stadt",
    enterCityName: "Stadtname eingeben",
    priceRange: "Preisbereich",
    min: "Min",
    max: "Max",
    radius: "Radius (km)",
    enterRadius: "Radius eingeben",
    searchButton: "Suchen",
    categoryTypes: "Kategorien",
    popularActivities: "Beliebte Aktivitäten",
    searchPlaceholder: "Aktivitäten, Orte oder Erlebnisse suchen...",
    allActivities: "Alle Aktivitäten",
    inspiration: {
      location: "Standort",
      price: "Preisbereich",
      bestTimeToVisit: "Beste Reisezeit",
      howToGetThere: "Anreise"
    },
    categories: {
      tour: "Führung",
      adventure: "Abenteuer",
      food: "Essen & Trinken",
      culture: "Kultur",
      sightseeing: "Sightseeing",
      entertainment: "Unterhaltung",
      nature: "Natur",
      wellness: "Wellness",
      sport: "Sport",
      workshop: "Workshop"
    }
  },
  newTrip: {
    title: "Neue Reise hinzufügen",
    bookingReference: "Buchungsreferenz",
    bookingReferenceDesc: "Geben Sie Ihre 6-stellige Buchungsreferenz ein und stellen Sie sicher, dass Vor- und Nachname in Ihrem Profil mit denen in Ihrer Reservierung übereinstimmen.",
    bookingRefPlaceholder: "Referenz (z.B. ABC123)",
    bookingRefTooShort: "Buchungsreferenz muss mindestens 6 Zeichen lang sein",
    bookingRefTooLong: "Buchungsreferenz darf maximal 10 Zeichen lang sein",
    lastNamePlaceholder: "Nachname",
    findBooking: "Buchung finden",
    gmailSync: "Mit Gmail synchronisieren",
    gmailSyncDesc: "Erlauben Sie uns, Ihren Gmail-Posteingang nach Reisebuchungen zu durchsuchen",
    connectGmail: "Gmail-Konto verbinden",
    emailForward: "Buchungs-E-Mail weiterleiten",
    emailForwardDesc: "Leiten Sie Ihre Buchungsbestätigung weiter, um Ihre Reise hinzuzufügen",
    emailCopied: "E-Mail-Adresse kopiert",
    emailCopiedDesc: "Die E-Mail-Adresse wurde in die Zwischenablage kopiert",
    copyEmail: "E-Mail-Adresse kopieren",
    manual: "Manuelle Eingabe",
    manualDesc: "Fügen Sie Ihre Reisedetails manuell hinzu",
    startManual: "Manuelle Eingabe starten",
    bookingSubmitted: "Buchung übermittelt",
    processingBooking: "Wir suchen nach Ihrer Buchung...",
    gmailConsent: "Gmail-Verbindung",
    gmailProcessing: "Verbindung zu Ihrem Gmail-Konto wird hergestellt...",
    manualEntry: "Manuelle Reiseeingabe",
    manualEntryDesc: "Erstellen Sie eine Reise, indem Sie selbst Flug- und Hoteldetails hinzufügen",
    drawer: {
      addTripDetails: "Reisedetails hinzufügen",
      tripInfo: "Reiseinformationen",
      tripName: "Reisename",
      tripType: "Reisetyp",
      selectTripType: "Reisetyp auswählen",
      leisure: "Freizeit",
      business: "Geschäft",
      family: "Familie",
      bleisure: "Geschäft und Freizeit",
      travelers: "Anzahl der Reisenden",
      addFlight: "Flug hinzufügen",
      flightNumber: "Flugnummer (z.B. LH1234)",
      departureDate: "Abflugdatum",
      addedFlights: "Hinzugefügte Flüge",
      from: "Von:",
      to: "Nach:",
      terminal: "Terminal:",
      departure: "Abflug:",
      arrival: "Ankunft:",
      addHotel: "Hotel hinzufügen",
      hotelName: "Hotelname",
      cityName: "Stadtname",
      selectCheckInOut: "Check-in und Check-out Daten auswählen",
      checkIn: "Check-in",
      checkOut: "Check-out",
      addedHotels: "Hinzugefügte Hotels",
      createTrip: "Reise erstellen",
      adding: "Wird hinzugefügt...",
      selectFlight: "Flug auswählen",
      confirmFlight: "Flug bestätigen",
      step1: "Info",
      step2: "Flüge",
      step3: "Hotels",
      step4: "Überprüfung",
      next: "Weiter",
      back: "Zurück",
      review: "Überprüfen",
      flightsStepEmpty: "Fügen Sie mindestens einen Flug zu Ihrer Reise hinzu",
      flightsStepWithFlights: "Sie haben {{count}} Flug/Flüge hinzugefügt",
      hotelsStepEmpty: "Fügen Sie Hotels zu Ihrer Reise hinzu (optional)",
      hotelsStepWithHotels: "Sie haben {{count}} Hotel(s) hinzugefügt",
      reviewTrip: "Überprüfen Sie Ihre Reise",
      reviewDescription: "Überprüfen Sie Ihre Reisedetails, bevor Sie sie erstellen",
      tripSummary: "Reisezusammenfassung",
      flightsSummary: "Flüge",
      hotelsSummary: "Hotels"
    },
    profileMismatch: "Entschuldigung, Ihre Profilinformationen stimmen nicht mit der Buchung überein. Bitte gehen Sie zu Ihrem Profil und stellen Sie sicher, dass Ihr Vor- und Nachname mit denen übereinstimmen, die für die Buchung verwendet wurden. Sie können auch versuchen, Ihre Reise mit den folgenden Optionen zu importieren, indem Sie Ihre Buchungsbestätigungs-E-Mail weiterleiten oder die Reise manuell eingeben."
  },
  index: {
    greeting: "Hallo, Reisender",
    greetingWithName: "Hallo, {{name}}",
    manageTrips: "Verwalten Sie Ihre Reisen",
    bookingRef: "Buchungsreferenz",
    lastName: "Nachname",
    addTrip: "Reise hinzufügen",
    timeline: "Ihre Zeitleiste",
    travelPlans: "Ihre Reisepläne",
    errorFetchingTrips: "Stellen Sie sicher, dass Sie mit einem Konto mit entsprechendem Namen und E-Mail verbunden sind.",
    viewUpcomingFlights: "Kommende Flüge anzeigen",
    welcome: {
      title: "Willkommen zu Ihrer Reise!",
      features: {
        tripManagement: {
          title: "Reiseverwaltung",
          description: "Behalten Sie alle Ihre Reisedetails an einem Ort - Flüge, Hotels und Aktivitäten."
        },
        tripAlerts: {
          title: "Reisebenachrichtigungen",
          description: "Erhalten Sie zeitnahe Benachrichtigungen über Ihre Flüge, Gate-Änderungen und wichtige Reiseupdates."
        },
        offers: {
          title: "Personalisierte Angebote",
          description: "Erhalten Sie maßgeschneiderte Reiseangebote basierend auf Ihren Vorlieben und vergangenen Reisen."
        },
        inspiration: {
          title: "Reiseinspiration",
          description: "Entdecken Sie neue Reiseziele und erhalten Sie personalisierte Empfehlungen für Ihre Abenteuer"
        }
      },
      tips: {
        profile: "Vervollständigen Sie Ihr Profil für personalisierte Empfehlungen",
        addTrip: "Klicken Sie auf die + Schaltfläche, um Ihre erste Reise hinzuzufügen",
        notifications: "Aktivieren Sie Benachrichtigungen, um keine wichtigen Reiseupdates zu verpassen",
        dates: "Verfolgen Sie wichtige Reisedaten in Ihrem Kalender"
      },
      getStarted: "Schnelle Tipps zum Einstieg",
      ready: "Bereit für Ihre Reise? Lassen Sie uns jede Reise unvergesslich machen! ✈️"
    },
    importAdtdTripSuccess: "Reise erfolgreich importiert",
    importAdtdTripError: "Reise konnte nicht in dieses Konto importiert werden",
    checkYourTrips: "Überprüfen Sie Ihre Reisen in der App"
  },
  weather: {
    in: "Wetter in",
    loading: "Lade Wetterdaten...",
    currentWeather: "Aktuelles Wetter",
    forecast: "Vorhersage",
    temperature: "Temperatur",
    feelsLike: "Gefühlt wie",
    wind: "Wind",
    humidity: "Luftfeuchtigkeit",
    precipitation: "Niederschlag",
    pressure: "Druck",
    visibility: "Sichtweite",
    uvIndex: "UV-Index",
    sunrise: "Sonnenaufgang",
    sunset: "Sonnenuntergang",
    daily: "Täglich",
    hourly: "Stündlich",
    today: "Heute",
    tomorrow: "Morgen",
    min: "Min",
    max: "Max"
  },
  sidebar: {
    myTrips: "Meine Reisen",
    discover: "Entdecken",
    newTrip: "Neue Reise",
    profile: "Profil",
    feedback: "Feedback"
  },
  errors: {
    configurationError: "Konfigurationsfehler",
    websiteNotConfigured: "Die Website ist nicht richtig konfiguriert."
  }
}
